import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export var getModuleByKey = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getAppForgeUIExtensions, moduleKey) {
    var _yield$getAppForgeUIE, extensions, module;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return getAppForgeUIExtensions({
            expandAppOwner: false
          });
        case 2:
          _yield$getAppForgeUIE = _context.sent;
          extensions = _yield$getAppForgeUIE.extensions;
          module = extensions === null || extensions === void 0 ? void 0 : extensions.find(function (_ref2) {
            var key = _ref2.key;
            return key === moduleKey;
          });
          return _context.abrupt("return", module !== null && module !== void 0 && module.type ? module : null);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getModuleByKey(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var NavigationError = {
  ModuleNotFound: function ModuleNotFound(moduleKey) {
    return new Error("Navigation failed: Module with moduleKey ".concat(moduleKey, " was not found"));
  },
  MissingProperty: function MissingProperty(property) {
    return new Error("Navigation failed: ".concat(property, " not provided"));
  },
  FailedToFetchContentInfo: function FailedToFetchContentInfo(contentId) {
    return new Error("Navigation failed: Failed to fetch content information with id ".concat(contentId, ". Please check if the ID provided is correct"));
  },
  NotSupportedExtensionType: function NotSupportedExtensionType(moduleType) {
    return new Error("Navigation failed: Module type ".concat(moduleType, " is not supported"));
  },
  InvalidValueForProperty: function InvalidValueForProperty(property, value) {
    return new Error("Navigation failed: ".concat(value, " is not a valid value for ").concat(property));
  },
  LinkForContentNotFound: function LinkForContentNotFound(contentId) {
    return new Error("Navigation failed: Link for content with id ".concat(contentId, " was not found"));
  }
};
export var ensurePropertyExists = function ensurePropertyExists(propertyName, propertyValue) {
  if (propertyValue === undefined || propertyValue === null) {
    throw NavigationError.MissingProperty(propertyName);
  }
  return propertyValue;
};